import { useLoadContext } from "../../context/LoadContext";
import FormView from "./FormView";

function Form({ id, onSubmit, loadingGroups, children, style, className }) {
  const loadContext = useLoadContext();

  /**
   * This method will prevent the native form submit and call the onSubmit
   * callback, unless the given loading groups are still busy
   * @param {event} e
   */
  function onFormSubmit(e) {
    e.preventDefault();

    if (loadContext.isLoading(loadingGroups)) {
      return;
    }

    if (onSubmit) {
      onSubmit(e);
    }
  }

  return (
    <FormView
      id={id}
      onSubmit={onFormSubmit}
      style={style}
      className={className}
    >
      {children}
    </FormView>
  );
}

export default Form;
